import { BaseItemStore } from "../../core/BaseStore";
import type BaseModuleDataModel from "./BaseModuleDataModel";
import type { BaseModuleModelData } from "./BaseModuleDataModel";

export default class ModulesDataStore extends BaseItemStore<
  BaseModuleDataModel<BaseModuleModelData>
> {}
